import { useEffect, useState } from "react";
import { Stamp } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Canvas, Controls, DEFAULTS } from "@/components/inbox/WatermarkEditor";
import { MediaThumb } from "@/components/inbox/InboxDialogs";

// The SAME Vault "Filigrana" window (preview, text, 9 positions/drag, size, color, opacity) for the Stripe path:
// its buttons go back to the Stripe window and never send anything in the chat.
export function StripeWmWindow({ items, initial, onApply, onRemove, onClose }) {
  const [p, setP] = useState(DEFAULTS);
  const [cur, setCur] = useState(0);
  const list = items || [];
  const open = list.length > 0;
  useEffect(() => { if (open) { setP(initial ? { ...DEFAULTS, ...initial } : DEFAULTS); setCur(0); } }, [open]); // eslint-disable-line
  const set = (u) => setP((x) => ({ ...x, ...u }));
  const m = open ? list[Math.min(cur, list.length - 1)] : null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl bg-[#0D0E14] border-[#232738] max-h-[92vh] overflow-y-auto" data-testid="stripe-wm-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Stamp className="h-4 w-4 text-violet-400" />Filigrana · {list.length > 1 ? `tutti i ${list.length} contenuti` : (m?.title || (m?.kind === "video" ? "Video" : "Foto"))}</DialogTitle></DialogHeader>
        {m && (
          <div className="grid md:grid-cols-[1fr_260px] gap-4">
            <div className="space-y-2">
              <div className="flex justify-center bg-black/30 rounded-md p-2"><Canvas key={m.id} media={m} p={p} onMove={set} /></div>
              {list.length > 1 && <div className="flex flex-wrap gap-1.5" data-testid="stripe-wm-items">{list.map((x, i) => (
                <button key={x.id} onClick={() => setCur(i)} className={`relative h-12 w-10 overflow-hidden rounded border-2 ${i === cur ? "border-violet-500" : "border-transparent"}`} data-testid={`stripe-wm-item-${i}`}><MediaThumb m={x} className="h-full w-full" /></button>))}</div>}
            </div>
            <Controls p={p} set={set} />
          </div>
        )}
        <p className="text-[11px] text-slate-500">La filigrana va su una copia: l'originale nel Vault resta intatto. Qui non viene inviato niente in chat.</p>
        <div className="flex flex-wrap justify-end gap-2 pt-2">
          <Button variant="secondary" onClick={onRemove} data-testid="stripe-wm-remove">Senza filigrana</Button>
          <Button onClick={() => onApply({ ...p, text: p.text.trim() })} disabled={!p.text.trim()} className="bg-violet-600 hover:bg-violet-500" data-testid="stripe-wm-apply">Applica filigrana</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
